import React from 'react';
import Button from '../../../components/ui/Button';
import BookingStatusBadge from './BookingStatusBadge';
import { Checkbox } from '../../../components/ui/Checkbox';
import { needsPriceFinalization } from '../../../utils/pricingUtils';

const BookingTableRow = ({ 
  booking, 
  isSelected, 
  onSelect, 
  canSelect = true,
  onViewDetails, 
  onContact 
}) => {
  const pricePrefix = needsPriceFinalization(booking) ? 'From ' : '';
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const formatTime = (timeString) => {
    const [hours, minutes] = timeString?.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-colors duration-250">
      {canSelect && (
        <td className="px-4 py-4">
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelect(booking?.id, e?.target?.checked)}
          />
        </td>
      )}
      <td className="px-4 py-4">
        <div className="flex flex-col">
          <span className="font-caption font-medium text-foreground">
            {booking?.clientName}
          </span>
          <span className="text-sm text-muted-foreground font-caption">
            {booking?.clientEmail}
          </span>
        </div>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm text-foreground font-caption whitespace-nowrap">
          {booking?.clientPhone}
        </span>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm text-foreground font-caption">
          {booking?.serviceName}
        </span>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm text-foreground font-caption whitespace-nowrap">
          {formatDate(booking?.date)}
        </span>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm text-foreground font-caption whitespace-nowrap">
          {formatTime(booking?.time)}
        </span>
      </td>
      <td className="px-4 py-4">
        <span className="text-sm font-semibold text-foreground font-caption whitespace-nowrap">
          {booking?.price != null ? `${pricePrefix}GH¢${Number(booking.price).toFixed(2)}` : '—'}
        </span>
      </td>
      <td className="px-4 py-4">
        <BookingStatusBadge status={booking?.status} />
      </td>
      <td className="px-4 py-4">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Eye"
            onClick={() => onViewDetails(booking)}
          >
            View
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Phone"
            onClick={() => onContact(booking)}
          >
            Contact
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default BookingTableRow;
